import { FC } from "react";
import { Stack, Typography } from "@mui/material";
import { WorkflowCreateButton } from "./WorkflowCreateButton";
import EmptyStateImage from "../../../../../../assets/empty-states/empty_schedules-list.png";

export const WorkflowsEmptyState: FC = () => {
  return (
    <Stack justifyContent="center" alignItems="center" mt={12}>
      <img src={EmptyStateImage} alt="EmptyStateImage" />
      <Typography component="h4" variant="h4" textAlign="center" mt={5}>
        It’s Time to plan your first Workflow!
      </Typography>
      <Typography variant="body1" textAlign="center" mt={2}>
        Choose the resources and parameters to run an automation workflow.
      </Typography>

      <WorkflowCreateButton />
    </Stack>
  );
};
